/* eslint-disable no-plusplus */
// Dependecies
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { reject } from 'lodash';

// Store
import dashboardCompany from '../../store/dashboardCompany';
import user from '../../store/user';
import dateService from '../../store/dateService';

// Hooks
import useLanguage from '../useLanguage';

// Image
import check from '../../../sass/images/icons/check.svg';

function useGarageWorkShops() {
  const [userStore] = user();
  const [, dashboardActions] = dashboardCompany();
  const [storeDate] = dateService();
  const [company, useSetCompany] = useState();
  const [totalService, useSetTotalService] = useState(0);
  const [totalServiceFinalized, useSetTotalServiceFinalized] = useState(0);
  const [lastService, useSetLastService] = useState(moment());
  const [totalTypesServices, useSetTotalTypesServices] = useState([]);
  const [openModal, useSetOpenModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [nextMaintenance] = useState(moment());
  const [valuePlate, setValuePlate] = useState(0);
  const [valuePlateDahsboard, setvaluePlateDahsboard] = useState(0);
  const [imagen, setImagen] = useState(check);
  const [filterCompany, setFilterCompany] = useState(false);
  const [errorPlate, setUseErrorPlate] = useState(false);
  const [packagesCompany, SetPackagesCompany] = useState(userStore.packages);

  const { locale } = useLanguage();
  const history = useHistory();

  useEffect(() => {
    SetPackagesCompany(userStore.packages);
  }, [userStore.packages]);

  useEffect(() => {
    if (userStore.token) {
      setReload(false);
      setvaluePlateDahsboard(valuePlate);
      setUseErrorPlate(false);
      dashboardActions.setDataCompany(userStore.token, valuePlate, locale).then(
        (response) => {
          useSetCompany(response.company.name);
          useSetTotalService(response.totalService);
          useSetTotalServiceFinalized(response.totalServiceFinalized);
          useSetLastService(response.last_service);
          if (response.totalServiceFinalized === 0) {
            useSetTotalTypesServices([{ name: 'No hay servicios finalizados ', total: 1 }]);
          } else {
            useSetTotalTypesServices(response.totalTypesServices);
          }
          setFilterCompany(false);
          setReload(true);
        },
        (e) => {
          if (e.status === 401) {
            reject(e);
          } else if (e.status === 400) {
            setUseErrorPlate(true);
            setReload(true);
            setFilterCompany(false);
          }
        }
      );
    }
  }, [userStore.token, filterCompany]);

  function searchLicensePlate(plate, img) {
    if (plate !== '') {
      setImagen(img);
    } else {
      setValuePlate(0);
      setImagen(img);
    }
    setFilterCompany(true);
    setReload(false);
  }

  function chegeModal() {
    useSetOpenModal(!openModal);
  }

  function redirect(route, dateRequest, dateSendRequest) {
    const url = `/${locale}/${route}`;
    history.push(url);
    if (dateRequest) {
      storeDate.dateRequest = dateSendRequest;
    }
  }

  const closeModal = () => {
    useSetOpenModal(false);
  };
  return {
    reload,
    company,
    totalService,
    totalServiceFinalized,
    totalTypesServices,
    chegeModal,
    openModal,
    redirect,
    nextMaintenance,
    valuePlate,
    imagen,
    searchLicensePlate,
    setValuePlate,
    closeModal,
    valuePlateDahsboard,
    errorPlate,
    lastService,
    packagesCompany,
  };
}

export default useGarageWorkShops;
